export const SMALL_SCREEN_WIDTH = 1024;
export const TABLET_MAX_WIDTH = 768;
export const PHONE_MAX_WIDTH = 480;